import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { doc, Timestamp, updateDoc } from "firebase/firestore";
import getJsUTC from "../../helpers/getJsUTC";
import HelperForMetaData from "../../helpers/HelperForMetaData";

const UpdatePropertyStatus = async (
  propertyId,
  SharedParties,
  NUMBER_OF_SHARED_PARTIES,
  e
) => {
  try {
    const PropertiesCollection = await doc(db, "properties", propertyId);
    const data = {
      sharedParties: SharedParties,
      numberOfSharedParties: NUMBER_OF_SHARED_PARTIES,
      status: e,
      sharedAt: Timestamp.fromDate(new Date(getJsUTC())),
      modifiedAt: getJsUTC(),
      modifiedBy: getAuth().currentUser.uid,
      ...HelperForMetaData(),
    };
    if (e === "inventory") {
      data.sharedAt = null;
    }
    delete data.createdAt;
    delete data.modifiedAt;

    await updateDoc(PropertiesCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default UpdatePropertyStatus;
